import { ITagScore } from '@/interfaces';
import { formatPercentage } from '@/utils';
import { Grid, Paper, Typography } from '@mui/material';

const KeyInterests: React.FC<{
  interests: ITagScore[];
}> = ({ interests }) => (
  <Grid
    xs={12}
    md={8}
    sx={{
      height: '100%',
    }}
  >
    <Paper
      sx={{
        padding: 3,
        flex: 1,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex',
      }}
    >
      <Typography variant="h6" mb={4} fontWeight={700}>
        Key Interests
      </Typography>
      <Grid container spacing={2} columnSpacing={1} rowSpacing={1}>
        {interests.map((interest, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Paper
              elevation={5}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                minWidth: 0,
                p: 2,
              }}
            >
              <Typography
                variant="body2"
                textAlign="center"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: '1',
                  WebkitBoxOrient: 'vertical',
                  fontWeight: 600,
                }}
              >
                {interest.name}
              </Typography>
              <Typography
                variant="body2"
                textAlign="center"
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: '1',
                  WebkitBoxOrient: 'vertical',
                  color: 'text.secondary',
                  mt: 0.5,
                }}
              >
                {formatPercentage(interest.penetration)}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Paper>
  </Grid>
);

export default KeyInterests;
